import { Dispatch } from "redux";
import {
  ForgotPasswordRequest,
  VerifyOtpData,
  ResetPasswordData,
} from "../../types/ForgotPassword";
import {
  requestOtp,
  verifyOtp,
  resetPassword,
} from "../../services/ForgotPasswordService";

export enum ForgotPasswordActionTypes {
  REQUEST_OTP_SUCCESS = "REQUEST_OTP_SUCCESS",
  VERIFY_OTP_SUCCESS = "VERIFY_OTP_SUCCESS",
  RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS",
  FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR",
}

interface RequestOtpSuccessAction {
  type: ForgotPasswordActionTypes.REQUEST_OTP_SUCCESS;
  message: string;
}
interface VerifyOtpSuccessAction {
  type: ForgotPasswordActionTypes.VERIFY_OTP_SUCCESS;
  message: string;
}
interface ResetPasswordSuccessAction {
  type: ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESS;
  message: string;
}
interface ForgotPasswordErrorAction {
  type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR;
  error: string;
}

export type ForgotPasswordActions =
  | RequestOtpSuccessAction
  | VerifyOtpSuccessAction
  | ResetPasswordSuccessAction
  | ForgotPasswordErrorAction;

export const requestOtpAction = (data: ForgotPasswordRequest) => {
  return async (dispatch: Dispatch) => {
    try {
      const res = await requestOtp(data);
      dispatch<RequestOtpSuccessAction>({
        type: ForgotPasswordActionTypes.REQUEST_OTP_SUCCESS,
        message: res.data.message,
      });
      return Promise.resolve(res.data.message);
    } catch (e: any) {
      const msg = e.response?.data?.message || "Failed to send OTP";
      dispatch<ForgotPasswordErrorAction>({
        type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR,
        error: msg,
      });
      return Promise.reject(msg);
    }
  };
};

export const verifyOtpAction = (employeeId: string, data: VerifyOtpData) => {
  return async (dispatch: Dispatch) => {
    try {
      const res = await verifyOtp(employeeId, data);
      dispatch<VerifyOtpSuccessAction>({
        type: ForgotPasswordActionTypes.VERIFY_OTP_SUCCESS,
        message: res.data.message,
      });
      return Promise.resolve(res.data.message);
    } catch (e: any) {
      const msg = e.response?.data?.message || "OTP verification failed";
      dispatch<ForgotPasswordErrorAction>({
        type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR,
        error: msg,
      });
      return Promise.reject(msg);
    }
  };
};

export const resetPasswordAction = (
  employeeId: string,
  data: ResetPasswordData,
) => {
  return async (dispatch: Dispatch) => {
    try {
      const res = await resetPassword(employeeId, data);
      dispatch<ResetPasswordSuccessAction>({
        type: ForgotPasswordActionTypes.RESET_PASSWORD_SUCCESS,
        message: res.data.message,
      });
      return Promise.resolve(res.data.message);
    } catch (e: any) {
      const msg = e.response?.data?.message || "Password reset failed";
      dispatch<ForgotPasswordErrorAction>({
        type: ForgotPasswordActionTypes.FORGOT_PASSWORD_ERROR,
        error: msg,
      });
      return Promise.reject(msg);
    }
  };
};
